/**
 * Centralized Placement Pricing Configuration
 *
 * To update prices, change values here — all pages that reference
 * placement pricing will automatically reflect the new values.
 */

export const PLACEMENT_PRICING = {
  /** Full Page placement base price (per region, one issue) */
  full_page: 100,
  /** Half Page (Coupon Book) — automatically calculated: 50% of full_page + $20 extra fee */
  get half_page() {
    return this.full_page / 2 + 20;
  },
} as const;

/**
 * Per-placement pricing map used in order wizard and order summary.
 * Keys match placement IDs in PLACEMENTS_CATALOG.
 * Values are { one: price_per_region_one_issue, three: price_per_region_three_issue }
 */
export const PLACEMENT_PRICES: Record<string, { one: number; three: number }> = {
  standard:              { one: 300,  three: 200  },
  half_page:             { one: 70,   three: 55   },
  ifc:                   { one: 650,  three: 500  },
  ibc:                   { one: 650,  three: 500  },
  bc:                    { one: 1500, three: 1200 },
  fc:                    { one: 2200, three: 2000 },
  flyer_insert:          { one: 500,  three: 400  },
  premium_flyer_insert:  { one: 750,  three: 600  },
};

/**
 * Placement display names — single source of truth for all UI labels.
 */
export const PLACEMENT_NAMES: Record<string, string> = {
  standard:             'Standard Inside Page',
  half_page:            'Half Page (Coupon Book)',
  ifc:                  'Inside Front Cover',
  ibc:                  'Inside Back Cover',
  bc:                   'Back Cover',
  fc:                   'Front Cover',
  flyer_insert:         'Flyer Insert',
  premium_flyer_insert: 'Premium Flyer Insert',
};

/** IDs that are flyer inserts (do not consume book pages) */
export const FLYER_INSERT_IDS = new Set(['flyer_insert', 'premium_flyer_insert']);
